__turbopack_context__.v({
  "active": "SideDrawer-module-scss-module__V7Rm-W__active",
  "createAccountActionSideDrawer": "SideDrawer-module-scss-module__V7Rm-W__createAccountActionSideDrawer",
  "disabled": "SideDrawer-module-scss-module__V7Rm-W__disabled",
  "emailEditText": "SideDrawer-module-scss-module__V7Rm-W__emailEditText",
  "emailRow": "SideDrawer-module-scss-module__V7Rm-W__emailRow",
  "emailText": "SideDrawer-module-scss-module__V7Rm-W__emailText",
  "itemActive": "SideDrawer-module-scss-module__V7Rm-W__itemActive",
  "itemsIcon": "SideDrawer-module-scss-module__V7Rm-W__itemsIcon",
  "loginButtonWrapper": "SideDrawer-module-scss-module__V7Rm-W__loginButtonWrapper",
  "menuItem": "SideDrawer-module-scss-module__V7Rm-W__menuItem",
  "menuItemIconWrapper": "SideDrawer-module-scss-module__V7Rm-W__menuItemIconWrapper",
  "menuList": "SideDrawer-module-scss-module__V7Rm-W__menuList",
  "openArrow": "SideDrawer-module-scss-module__V7Rm-W__openArrow",
  "sideDrawerBtn": "SideDrawer-module-scss-module__V7Rm-W__sideDrawerBtn",
  "sideDrawerPhoneNumber": "SideDrawer-module-scss-module__V7Rm-W__sideDrawerPhoneNumber",
  "sideDrawerTagLine": "SideDrawer-module-scss-module__V7Rm-W__sideDrawerTagLine",
  "sideDrawerUserName": "SideDrawer-module-scss-module__V7Rm-W__sideDrawerUserName",
  "sideDrawerUserProfile": "SideDrawer-module-scss-module__V7Rm-W__sideDrawerUserProfile",
});
